
import { language } from '@/common/storage';

export default {
  props: {
    resource: {
      type: Object,
      required: true
    },

    index: {
      type: Number,
      required: true
    },

    editable: {
      type: Boolean,
      default: false
    },

    changeable: {
      type: Boolean,
      default: false
    },

    removable: {
      type: Boolean,
      default: false
    },

    downloadable: {
      type: Boolean,
      default: true
    },

    modelDownloadable: {
      type: Boolean,
      default: false
    },
    uploadable: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      hoverIndex: false
    };
  },


  computed: {
    visibleHandler: function visibleHandler() {
      return this.editable || this.changeable || this.removable;
    },
    popoverWidth: function popoverWidth() {
      if (language.get() === 'en') {
        return 60;
      }
      return 50;
    }
  }
};